// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "appointment_deposit_allocation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "appointment_deposit_allocation" table (1:1 with a DB row, on the wire). */
export const appointmentDepositAllocationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    depositId: z.string(),
    appointmentId: z.string(),
    amountCents: z.number(),
    refundedAmountCents: z.number(),
    refundReservedCents: z.number(),
    forfeitedAmountCents: z.number(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=appointmentDepositAllocation.js.map